import {Component, OnInit} from '@angular/core';
import {AuthService} from 'shared';
import {Router} from '@angular/router';
import {notify} from 'shared';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
  email = '';
  password = '';
  rememberMe = true;
  loadIndicatorVisible = false;

  constructor(private authService: AuthService, private router: Router) {
  }

  onLoginClick(args) {
    if (!args.validationGroup.validate().isValid) {
      return;
    }
    this.loadIndicatorVisible = true;

    this.authService.login(this.email, this.password, this.rememberMe).subscribe(
      () => {
        this.router.navigate(['/']);
      }, () => {
        notify('L\'e-mail ou le mot de passe est incorrect. Veuillez réessayer.', 'warning');
        this.loadIndicatorVisible = false;
      });

    // args.validationGroup.reset();
  }

  ngOnInit(): void {
  }

}
